
import React from "react";
import "./LoadingIndicator.css";

const LoadingIndicator = ({ message = "Loading..." }) => {
  return (
    <div className="loading-container">
      <div className="animated-spinner">
        <div className="dot"></div>
        <div className="dot"></div>
        <div className="dot"></div>
      </div>
      <p className="loading-message">{message}</p>
    </div>
  );
};

export default LoadingIndicator;
